import { render, staticRenderFns } from "./HealthQuestionnaires.vue?vue&type=template&id=421c0185&scoped=true&"
import script from "./HealthQuestionnaires.vue?vue&type=script&lang=js&"
export * from "./HealthQuestionnaires.vue?vue&type=script&lang=js&"
import style0 from "./HealthQuestionnaires.vue?vue&type=style&index=0&id=421c0185&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421c0185",
  null
  
)

export default component.exports